import React from 'react';
import loadable from '@loadable/component';

import getPageDataLoadingAPI from '../containers/pageDataLoadingAPI';
import NotFoundPage from '../containers/NotFoundPage/NotFoundPage';
import PreviewResolverPage from '../containers/PreviewResolverPage/PreviewResolverPage';

// routeConfiguration needs to initialize containers first
// Otherwise, components will import form container eventually and
// at that point css bundling / imports will happen in wrong order.
import { NamedRedirect } from '../components';
import PassportRequiredPage from '../containers/PassportRequiredPage/PassportRequiredPage';
import { newInboxEnabled } from '../util/newInbox';

const pageDataLoadingAPI = getPageDataLoadingAPI();

const AboutPage = loadable(() => import(/* webpackChunkName: "AboutPage" */ '../containers/AboutPage/AboutPage'));
const AdminDashboardPage = loadable(() => import(/* webpackChunkName: "AdminDashboardPage" */ '../containers/AdminDashboard/AdminDashboard'));
const BlogPage = loadable(() => import(/* webpackChunkName: "BlogPage" */ '../containers/BlogPage/BlogPage'));
const BlogPost = loadable(() => import(/* webpackChunkName: "BlogPost" */ '../containers/BlogPage/BlogPost/BlogPost'));
const AuthenticationPage = loadable(() => import(/* webpackChunkName: "AuthenticationPage" */ '../containers/AuthenticationPage/AuthenticationPage'));
const CheckoutPage = loadable(() => import(/* webpackChunkName: "CheckoutPage" */ '../containers/CheckoutPage/CheckoutPage'));
const CMSPage = loadable(() => import(/* webpackChunkName: "CMSPage" */ '../containers/CMSPage/CMSPage'));
const ContactDetailsPage = loadable(() => import(/* webpackChunkName: "ContactDetailsPage" */ '../containers/ContactDetailsPage/ContactDetailsPage'));
const DealNotificationsPage = loadable(() => import(/* webpackChunkName: "DealNotificationsPage" */ '../containers/DealNotificationsPage/DealNotificationsPage'));
const ContactPage = loadable(() => import(/* webpackChunkName: "ContactPage" */ '../containers/ContactPage/ContactPage'));
const DebtPage = loadable(() => import(/* webpackChunkName: "DebtPage" */ '../containers/DebtPage/DebtPage'));
const JackPage = loadable(() => import(/* webpackChunkName: "JackPage" */ '../containers/TeamPages/JackPage/JackPage'));
const LegalPage = loadable(() => import(/* webpackChunkName: "LegalPage" */ '../containers/LegalPage/LegalPage'));
const MishconPage = loadable(() => import(/* webpackChunkName: "MishconPage" */ '../containers/TeamPages/MishconPage/MishconPage'));
const TeamAmPage = loadable(() => import(/* webpackChunkName: "TeamAmPage" */ '../containers/TeamAmPage/TeamAmPage'));
const EditListingPage = loadable(() => import(/* webpackChunkName: "EditListingPage" */ '../containers/EditListingPage/EditListingPage'));
const EmailVerificationPage = loadable(() => import(/* webpackChunkName: "EmailVerificationPage" */ '../containers/EmailVerificationPage/EmailVerificationPage'));
const FavoriteListingsPage = loadable(() => import(/* webpackChunkName: "FavoriteListingsPage" */ '../containers/FavoriteListingsPage/FavoriteListingsPage'));
const InboxPage = loadable(() => import(/* webpackChunkName: "InboxPage" */ '../containers/InboxPage/InboxPage'));
const DealInboxPage = loadable(() => import(/* webpackChunkName: "DealInboxPage" */ '../containers/DealInboxPage/DealInboxPage'));
const LandingPage = loadable(() => import(/* webpackChunkName: "LandingPage" */ '../containers/LandingPage/LandingPage'));
const ListingPageCoverPhoto = loadable(() => import(/* webpackChunkName: "ListingPageCoverPhoto" */ /* webpackPrefetch: true */ '../containers/ListingPage/ListingPageCoverPhoto'));
const ListingPageCarousel = loadable(() => import(/* webpackChunkName: "ListingPageCarousel" */ /* webpackPrefetch: true */ '../containers/ListingPage/ListingPageCarousel'));
const ManageListingsPage = loadable(() => import(/* webpackChunkName: "ManageListingsPage" */ '../containers/ManageListingsPage/ManageListingsPage'));
const ModernLandingPage = loadable(() => import(/* webpackChunkName: "ModernLandingPage" */ '../containers/ModernLandingPage/ModernLandingPage'));
const MyHubPage = loadable(() => import(/* webpackChunkName: "MyHubPage" */ '../containers/MyHubPage/MyHubPage'));
const MyHubAllPage = loadable(() => import(/* webpackChunkName: "MyHubAllPage" */ '../containers/MyHubPage/MyHubAllPage'));
const NewsletterPage = loadable(() => import(/* webpackChunkName: "NewsletterPage" */ '../containers/NewsletterPage/NewsletterPage'));
const PasswordChangePage = loadable(() => import(/* webpackChunkName: "PasswordChangePage" */ '../containers/PasswordChangePage/PasswordChangePage'));
const UploadPassportPage = loadable(() => import(/* webpackChunkName: "UploadPassportPage" */ '../containers/UploadPassportPage/UploadPassportPage'));
const PasswordRecoveryPage = loadable(() => import(/* webpackChunkName: "PasswordRecoveryPage" */ '../containers/PasswordRecoveryPage/PasswordRecoveryPage'));
const PasswordResetPage = loadable(() => import(/* webpackChunkName: "PasswordResetPage" */ '../containers/PasswordResetPage/PasswordResetPage'));
const PaymentMethodsPage = loadable(() => import(/* webpackChunkName: "PaymentMethodsPage" */ '../containers/PaymentMethodsPage/PaymentMethodsPage'));
const PrivacyPolicyPage = loadable(() => import(/* webpackChunkName: "PrivacyPolicyPage" */ '../containers/PrivacyPolicyPage/PrivacyPolicyPage'));
const ProfilePage = loadable(() => import(/* webpackChunkName: "ProfilePage" */ '../containers/ProfilePage/ProfilePage'));
const ProfileSettingsPage = loadable(() => import(/* webpackChunkName: "ProfileSettingsPage" */ '../containers/ProfileSettingsPage/ProfileSettingsPage'));
const SearchPageWithMap = loadable(() => import(/* webpackChunkName: "SearchPageWithMap" */ /* webpackPrefetch: true */  '../containers/SearchPage/SearchPageWithMap'));
const SearchPageWithGrid = loadable(() => import(/* webpackChunkName: "SearchPageWithGrid" */ /* webpackPrefetch: true */  '../containers/SearchPage/SearchPageWithGrid'));
const StripePayoutPage = loadable(() => import(/* webpackChunkName: "StripePayoutPage" */ '../containers/StripePayoutPage/StripePayoutPage'));
const SubscriptionsPage = loadable(() => import(/* webpackChunkName: "SubscriptionsPage" */ '../containers/SubscriptionsPage/SubscriptionsPage'));
const TermsOfServicePage = loadable(() => import(/* webpackChunkName: "TermsOfServicePage" */ '../containers/TermsOfServicePage/TermsOfServicePage'));
const TestimonialsPage = loadable(() => import(/* webpackChunkName: "TestimonialsPage" */ '../containers/TestimonialsPage/TestimonialsPage'));
const TransactionPage = loadable(() => import(/* webpackChunkName: "TransactionPage" */ '../containers/TransactionPage/TransactionPage'));
const ConversationRedirectPage = loadable(() => import(/* webpackChunkName: "ConversationRedirectPage" */ '../containers/ConversationRedirectPage/ConversationRedirectPage'));
const CustomLandingPage = loadable(() => import(/* webpackChunkName: "CustomLandingPage" */ '../containers/CustomLandingPage/CustomLandingPage'));
const ValidatePaymentPage = loadable(() => import(/* webpackChunkName: "ValidatePaymentPage" */ '../containers/ValidatePaymentPage/ValidatePaymentPage'));

// Styleguide helps you to review current components and develop new ones
const StyleguidePage = loadable(() => import(/* webpackChunkName: "StyleguidePage" */ '../containers/StyleguidePage/StyleguidePage'));

export const ACCOUNT_SETTINGS_PAGES = [
  'ContactDetailsPage',
  'PasswordChangePage',
  'StripePayoutPage',
  'PaymentMethodsPage',
  'UploadPassportPage',
];

// https://en.wikipedia.org/wiki/Universally_unique_identifier#Nil_UUID
const draftId = '00000000-0000-0000-0000-000000000000';
const draftSlug = 'draft';

const RedirectToLandingPage = () => <NamedRedirect name="LandingPage" />;

// NOTE: Most server-side endpoints are prefixed with /api. Requests to those
// endpoints are indended to be handled in the server instead of the browser and
// they will not render the application. So remember to avoid routes starting
// with /api and if you encounter clashing routes see server/index.js if there's
// a conflicting route defined there.

// Our routes are exact by default.
// See behaviour from Routes.js where Route is created.
const routeConfiguration = (layoutConfig) => {
  const SearchPage = layoutConfig.searchPage?.variantType === 'map'
    ? SearchPageWithMap
    : SearchPageWithGrid;
  const ListingPage = layoutConfig.listingPage?.variantType === 'carousel'
    ? ListingPageCarousel
    : ListingPageCoverPhoto;

  // The new inbox (REACT_APP_NEW_INBOX=on): /inbox and /inbox/deal/:id. The old
  // route names stay, as redirects, because links all over the app (and in
  // emails, WhatsApp buttons and the payment return) still use them. Their
  // query string is kept, so ?action=request-intro still reaches the deal.
  const toDeal = props => (
    <NamedRedirect
      name="DealInboxDealPage"
      params={{ id: props.params?.id }}
      search={props.location?.search || ''}
    />
  );
  const dealInboxRoutes = [
    {
      path: '/inbox',
      name: 'DealInboxPage',
      auth: true,
      authPage: 'LoginPage',
      component: DealInboxPage,
      loadData: pageDataLoadingAPI.DealInboxPage.loadData,
    },
    {
      path: '/inbox/deal/:id',
      name: 'DealInboxDealPage',
      auth: true,
      authPage: 'LoginPage',
      component: DealInboxPage,
      loadData: pageDataLoadingAPI.DealInboxPage.loadData,
    },
    {
      // Never matched (DealInboxPage has the same path): only for links.
      path: '/inbox',
      name: 'InboxBasePage',
      auth: true,
      authPage: 'LoginPage',
      component: () => <NamedRedirect name="DealInboxPage" />,
    },
    {
      // The old tabs: sales = your listings, orders = your enquiries.
      path: '/inbox/:tab',
      name: 'InboxPage',
      auth: true,
      authPage: 'LoginPage',
      component: props => (
        <NamedRedirect
          name="DealInboxPage"
          search={props.params?.tab === 'orders' ? '?tab=enquiries' : '?tab=listings'}
        />
      ),
    },
    { path: '/order/:id', name: 'OrderDetailsPage', auth: true, authPage: 'LoginPage', component: toDeal },
    { path: '/order/:id/details', name: 'OrderDetailsPageRedirect', auth: true, authPage: 'LoginPage', component: toDeal },
    { path: '/sale/:id', name: 'SaleDetailsPage', auth: true, authPage: 'LoginPage', component: toDeal },
    { path: '/sale/:id/details', name: 'SaleDetailsPageRedirect', auth: true, authPage: 'LoginPage', component: toDeal },
    { path: '/t/:id', name: 'ConversationRedirectPage', auth: true, authPage: 'LoginPage', component: toDeal },
  ];

  // The Sharetribe inbox and chat, while the new inbox is off.
  const sharetribeInboxRoutes = [
    {
      path: '/inbox',
      name: 'InboxBasePage',
      auth: true,
      authPage: 'LoginPage',
      component: () => <NamedRedirect name="InboxPage" params={{ tab: 'sales' }} />,
    },
    {
      path: '/inbox/:tab',
      name: 'InboxPage',
      auth: true,
      authPage: 'LoginPage',
      component: InboxPage,
      loadData: pageDataLoadingAPI.InboxPage.loadData,
    },
    {
      path: '/order/:id',
      name: 'OrderDetailsPage',
      auth: true,
      authPage: 'LoginPage',
      component: TransactionPage,
      extraProps: { transactionRole: 'customer' },
      loadData: (params, ...rest) =>
        pageDataLoadingAPI.TransactionPage.loadData({ ...params, transactionRole: 'customer' }, ...rest),
      setInitialValues: pageDataLoadingAPI.TransactionPage.setInitialValues,
    },
    {
      // One link for either party: resolves to /order/:id or /sale/:id for
      // whoever is signed in, and 404s for anyone else.
      path: '/t/:id',
      name: 'ConversationRedirectPage',
      auth: true,
      authPage: 'LoginPage',
      component: ConversationRedirectPage,
      loadData: pageDataLoadingAPI.ConversationRedirectPage.loadData,
    },
    {
      path: '/order/:id/details',
      name: 'OrderDetailsPageRedirect',
      auth: true,
      authPage: 'LoginPage',
      component: props => <NamedRedirect name="OrderDetailsPage" params={{ id: props.params?.id }} />,
    },
    {
      path: '/sale/:id',
      name: 'SaleDetailsPage',
      auth: true,
      authPage: 'LoginPage',
      component: TransactionPage,
      extraProps: { transactionRole: 'provider' },
      loadData: pageDataLoadingAPI.TransactionPage.loadData,
    },
    {
      path: '/sale/:id/details',
      name: 'SaleDetailsPageRedirect',
      auth: true,
      authPage: 'LoginPage',
      component: props => <NamedRedirect name="SaleDetailsPage" params={{ id: props.params?.id }} />,
    },
  ];

  return [
    {
      path: '/',
      name: 'LandingPage',
      loadData: pageDataLoadingAPI.ModernLandingPage.loadData,
      component: ModernLandingPage,
    },
    {
      path: '/cars',
      name: 'CarsLandingPage',
      loadData: pageDataLoadingAPI.ModernLandingPage.loadData,
      component: ModernLandingPage,
    },
    {
      path: '/re',
      name: 'RealEstateLandingPage',
      loadData: pageDataLoadingAPI.ModernLandingPage.loadData,
      component: ModernLandingPage,
    },
    {
      path: '/old-landing-page',
      name: 'OldLandingPage',
      component: CustomLandingPage,
    },
    {
      path: '/admin-dashboard',
      name: 'AdminDashboardPage',
      component: AdminDashboardPage,
    },
    {
      path: '/about',
      name: 'AboutPage',
      component: AboutPage,
    },
    {
      path: '/blog',
      name: 'BlogPage',
      component: BlogPage,
    },
    {
      path: '/blog/:postUniqueLink',
      name: 'BlogPost',
      component: BlogPost,
    },
    {
      path: '/testimonials',
      name: 'TestimonialsPage',
      component: TestimonialsPage,
    },
    {
      path: '/contact',
      name: 'ContactPage',
      component: ContactPage,
    },
    {
      path: '/debt',
      name: 'DebtPage',
      component: DebtPage,
    },
    {
      // Members only: each enquiry is emailed straight to Mishcon de Reya.
      path: '/legal',
      name: 'LegalPage',
      auth: true,
      authPage: 'LoginPage',
      component: LegalPage,
    },
    {
      path: '/team',
      name: 'TeamAmPage',
      component: TeamAmPage,
      // The managers come from the database now, so they have to be fetched.
      // Doing it here means they are also in the server-rendered HTML, which
      // is what search engines read.
      loadData: pageDataLoadingAPI.TeamAmPage.loadData,
    },
    {
      path: '/team/jack',
      name: 'JackPage',
      component: JackPage,
    },
    {
      path: '/team/mishcon',
      name: 'MishconPage',
      component: MishconPage,
    },
    {
      path: '/newsletter',
      name: 'NewsletterPage',
      component: NewsletterPage,
    },
    {
      path: '/my-hub',
      name: 'MyHubPage',
      auth: true,
      component: MyHubPage,
      loadData: pageDataLoadingAPI.MyHubPage.loadData,
    },
    {
      // Member area: all the matches; Home shows the 10 newest.
      path: '/my-hub/all',
      name: 'MyHubAllPage',
      auth: true,
      component: MyHubAllPage,
      loadData: pageDataLoadingAPI.MyHubPage.loadData,
    },
    {
      path: '/favourites',
      name: 'FavoriteListingsPage',
      auth: true,
      authPage: 'LoginPage',
      component: FavoriteListingsPage,
      loadData: pageDataLoadingAPI.FavoriteListingsPage.loadData,
    },
    {
      path: '/p/:pageId',
      name: 'CMSPage',
      component: CMSPage,
      loadData: pageDataLoadingAPI.CMSPage.loadData,
    },
    {
      path: '/s',
      name: 'SearchPage',
      component: SearchPage,
      loadData: pageDataLoadingAPI.SearchPage.loadData,
    },
    {
      path: '/c/:catId',
      name: 'SearchPageByCategory',
      component: props => <NamedRedirect name="SearchPage" search={`?pub_categoryLevel1=${props.params?.catId}`} />,
    },
    {
      path: '/l',
      name: 'ListingBasePage',
      component: RedirectToLandingPage,
    },
    {
      path: '/l/:slug/:id',
      name: 'ListingPage',
      component: ListingPage,
      loadData: pageDataLoadingAPI.ListingPage.loadData,
    },
    {
      path: '/l/:slug/:id/checkout',
      name: 'CheckoutPage',
      auth: true,
      component: CheckoutPage,
      setInitialValues: pageDataLoadingAPI.CheckoutPage.setInitialValues,
    },
    {
      path: '/l/:slug/:id/:variant',
      name: 'ListingPageVariant',
      auth: true,
      authPage: 'LoginPage',
      component: ListingPage,
      loadData: pageDataLoadingAPI.ListingPage.loadData,
    },
    {
      path: '/l/new',
      name: 'NewListingPage',
      auth: true,
      extraProps: { contactInstead: true },
      component: () => (
        <NamedRedirect
          name="EditListingPage"
          params={{ slug: draftSlug, id: draftId, type: 'new', tab: 'details' }}
        />
      ),
    },
    {
      path: '/l/:slug/:id/:type/:tab',
      name: 'EditListingPage',
      auth: true,
      extraProps: { contactInstead: true },
      component: EditListingPage,
      loadData: pageDataLoadingAPI.EditListingPage.loadData,
    },
    {
      path: '/l/:slug/:id/:type/:tab/:returnURLType',
      name: 'EditListingStripeOnboardingPage',
      auth: true,
      component: EditListingPage,
      loadData: pageDataLoadingAPI.EditListingPage.loadData,
    },

    // Canonical path should be after the `/l/new` path since they
    // conflict and `new` is not a valid listing UUID.
    {
      path: '/l/:id',
      name: 'ListingPageCanonical',
      component: ListingPage,
      loadData: pageDataLoadingAPI.ListingPage.loadData,
    },
    {
      path: '/subscriptions',
      name: 'SubscriptionsPage',
      auth: true,
      component: SubscriptionsPage,
    },
    {
      path: '/validate-payment',
      name: 'ValidatePaymentPage',
      component: ValidatePaymentPage,
    },
    {
      path: '/u',
      name: 'ProfileBasePage',
      component: RedirectToLandingPage,
    },
    {
      path: '/u/:id',
      name: 'ProfilePage',
      component: ProfilePage,
      loadData: pageDataLoadingAPI.ProfilePage.loadData,
    },
    {
      path: '/profile-settings',
      name: 'ProfileSettingsPage',
      auth: true,
      authPage: 'LoginPage',
      component: ProfileSettingsPage,
    },

    // Note: authenticating with IdP (e.g. Facebook) expects that /login path exists
    // so that in the error case users can be redirected back to the LoginPage
    // In case you change this, remember to update the route in server/api/auth/loginWithIdp.js
    {
      path: '/login',
      name: 'LoginPage',
      component: AuthenticationPage,
      extraProps: { tab: 'login' },
    },
    {
      path: '/signup/:membershipId',
      name: 'SignupPage',
      component: AuthenticationPage,
      extraProps: { tab: 'signup' },
      loadData: pageDataLoadingAPI.AuthenticationPage.loadData,
    },
    {
      path: '/confirm',
      name: 'ConfirmPage',
      component: AuthenticationPage,
      extraProps: { tab: 'confirm' },
      loadData: pageDataLoadingAPI.AuthenticationPage.loadData,
    },
    {
      path: '/recover-password',
      name: 'PasswordRecoveryPage',
      component: PasswordRecoveryPage,
    },
    ...(newInboxEnabled() ? dealInboxRoutes : sharetribeInboxRoutes),
    {
      path: '/listings',
      name: 'ManageListingsPage',
      auth: true,
      authPage: 'LoginPage',
      component: ManageListingsPage,
      loadData: pageDataLoadingAPI.ManageListingsPage.loadData,
    },
    {
      path: '/account',
      name: 'AccountSettingsPage',
      auth: true,
      authPage: 'LoginPage',
      component: () => <NamedRedirect name="ContactDetailsPage" />,
    },
    {
      path: '/account/contact-details',
      name: 'ContactDetailsPage',
      auth: true,
      authPage: 'LoginPage',
      component: ContactDetailsPage,
      loadData: pageDataLoadingAPI.ContactDetailsPage.loadData,
    },
    {
      // Member area: notification settings and deal preferences (the
      // Contact details page and the profile page's preferences, together;
      // user, 2026-10-27). Off: goes to the profile page.
      path: '/account/deal-notifications',
      name: 'DealNotificationsPage',
      auth: true,
      authPage: 'LoginPage',
      component: DealNotificationsPage,
      loadData: pageDataLoadingAPI.ContactDetailsPage.loadData,
    },
    {
      path: '/account/change-password',
      name: 'PasswordChangePage',
      auth: true,
      authPage: 'LoginPage',
      component: PasswordChangePage,
    },
    {
      path: '/account/upload-passport',
      name: 'UploadPassportPage',
      auth: true,
      authPage: 'LoginPage',
      component: UploadPassportPage,
    },
    {
      path: '/account/payments',
      name: 'StripePayoutPage',
      auth: true,
      authPage: 'LoginPage',
      component: StripePayoutPage,
      loadData: pageDataLoadingAPI.StripePayoutPage.loadData,
    },
    {
      path: '/account/payments/:returnURLType',
      name: 'StripePayoutOnboardingPage',
      auth: true,
      authPage: 'LoginPage',
      component: StripePayoutPage,
      loadData: pageDataLoadingAPI.StripePayoutPage.loadData,
    },
    {
      path: '/account/payment-methods',
      name: 'PaymentMethodsPage',
      auth: true,
      authPage: 'LoginPage',
      component: PaymentMethodsPage,
      loadData: pageDataLoadingAPI.PaymentMethodsPage.loadData,
    },
    {
      path: '/terms-of-service',
      name: 'TermsOfServicePage',
      component: TermsOfServicePage,
      loadData: pageDataLoadingAPI.TermsOfServicePage.loadData,
    },
    {
      path: '/privacy-policy',
      name: 'PrivacyPolicyPage',
      component: PrivacyPolicyPage,
      loadData: pageDataLoadingAPI.PrivacyPolicyPage.loadData,
    },
    {
      path: '/styleguide',
      name: 'Styleguide',
      component: StyleguidePage,
    },
    {
      path: '/styleguide/g/:group',
      name: 'StyleguideGroup',
      component: StyleguidePage,
    },
    {
      path: '/styleguide/c/:component',
      name: 'StyleguideComponent',
      component: StyleguidePage,
    },
    {
      path: '/styleguide/c/:component/:example',
      name: 'StyleguideComponentExample',
      component: StyleguidePage,
    },
    {
      path: '/styleguide/c/:component/:example/raw',
      name: 'StyleguideComponentExampleRaw',
      component: StyleguidePage,
      extraProps: { raw: true },
    },
    {
      path: '/notfound',
      name: 'NotFoundPage',
      component: props => <NotFoundPage {...props} />,
    },
    {
      path: '/verification-in-progress',
      name: 'PassportRequiredPage',
      component: props => <PassportRequiredPage {...props} />,
    },

    // Do not change this path!
    //
    // The API expects that the application implements /reset-password endpoint
    {
      path: '/reset-password',
      name: 'PasswordResetPage',
      component: PasswordResetPage,
    },

    // Do not change this path!
    //
    // The API expects that the application implements /verify-email endpoint
    {
      path: '/verify-email',
      name: 'EmailVerificationPage',
      auth: true,
      authPage: 'LoginPage',
      component: EmailVerificationPage,
      loadData: pageDataLoadingAPI.EmailVerificationPage.loadData,
    },
    // Do not change this path!
    //
    // The API expects that the application implements /preview endpoint
    {
      path: '/preview',
      name: 'PreviewResolverPage',
      component: PreviewResolverPage,
    },
  ];
};

export default routeConfiguration;
